import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { getDefaultDateRange, PERIOD, PERIOD_TYPE } from 'shared/constants/date';

import { Button, Space } from 'antd';
import Modal from 'components/Modal';

import DateSelection from './date-selection';
import './date-range-picker.less';
import messages from './messages';

const DateRangePickerModal = ({ open, onChange, onCancel, value, defaultValue, allowCompare = true }) => {
  const [dateRange, setDateRange] = useState(null);

  useEffect(() => {
    setDateRange(value || defaultValue || getDefaultDateRange());
  }, [value, defaultValue]);

  const handleApply = () => {
    onChange(dateRange);
  };

  const handleReset = () => {
    onChange(defaultValue !== undefined ? defaultValue : getDefaultDateRange());
  };

  const predefinedDate = (args) => {
    onChange(getDefaultDateRange(args));
  };

  return (
    <Modal
      wrapClassName="date-range-picker__modal"
      width={650}
      open={open}
      onCancel={onCancel}
      title={<FormattedMessage {...messages.selectDateRanges} />}
      footer={[
        <Button key="reset" className="reset" danger onClick={handleReset}>
          <FormattedMessage {...messages.reset} />
        </Button>,
        <Button key="cancel" onClick={onCancel}>
          <FormattedMessage {...messages.cancel} />
        </Button>,
        <Button key="apply" type="primary" onClick={handleApply}>
          <FormattedMessage {...messages.apply} />
        </Button>,
      ]}
    >
      <h3><FormattedMessage {...messages.presets} /></h3>
      <Space style={{ marginBottom: '1em' }}>
        <Button onClick={() => predefinedDate({ period: PERIOD.WEEK, periodType: PERIOD_TYPE.LAST, lastNumberInput: 1 })}>
          <FormattedMessage {...messages.lastWeek} />
        </Button>
        <Button onClick={() => predefinedDate({ period: PERIOD.MONTH, periodType: PERIOD_TYPE.LAST, lastNumberInput: 1 })}>
          <FormattedMessage {...messages.lastMonth} />
        </Button>
        <Button onClick={() => predefinedDate({ period: PERIOD.QUARTER, periodType: PERIOD_TYPE.LAST, lastNumberInput: 1 })}>
          <FormattedMessage {...messages.lastQuarter} />
        </Button>
        <Button onClick={() => predefinedDate({ period: PERIOD.YEAR, periodType: PERIOD_TYPE.LAST, lastNumberInput: 1 })}>
          <FormattedMessage {...messages.lastYear} />
        </Button>
      </Space>
      <h3><FormattedMessage {...messages.customRange} /></h3>
      <DateSelection
        defaultValue={defaultValue}
        value={dateRange}
        onChange={updated => setDateRange(updated)}
        allowCompare={allowCompare}
      />
    </Modal>
  );
};

export default DateRangePickerModal;
